import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ContactService {
    private baseUrl = 'https://apiv2.clico.com.mx/api/alamov2';

    constructor(private http: HttpClient) {}

    private getCookie(name: string): string | null {
        const match = document.cookie.match(
            new RegExp('(^| )' + name + '=([^;]+)'),
        );
        return match ? match[2] : null;
    }

    sendContact(data: any, captcha: string): Observable<any> {
        const body = new FormData();
        body.append('nombre', data.nombre);
        body.append('telefono', data.telefono);
        body.append('telefonoOficina', data.telefonoOficina || '');
        body.append('correo', data.correo);
        body.append('estado', data.estado);
        body.append('municipio', data.municipio);
        body.append('empresa', data.empresa);
        body.append('giro', data.giro);
        body.append('puesto', data.puesto);
        body.append('landing_page', data.landing_page || '');
        body.append('g-recaptcha-response', captcha);

        const hubspotutk = this.getCookie('hubspotutk');
        if (hubspotutk) {
            body.append('hubspotutk', hubspotutk);
        }

        return this.http.post(`${this.baseUrl}/contact`, body);
    }
}
